import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestQuotes } from '../../../helpers/adipiBackendUrl';
import { getTable, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTQUOTE,
  DELETE_LABREQUESTQUOTE,
  GET_LABREQUESTQUOTES,
  UPDATE_LABREQUESTQUOTE,
  UPDATE_LABREQUESTQUOTE_STATUS
} from "./actionTypes";
import {
  addLabRequestQuoteFail,
  addLabRequestQuoteSuccess,
  deleteLabRequestQuoteFail,
  deleteLabRequestQuoteSuccess,
  getLabRequestQuotesFail,
  getLabRequestQuotesSuccess,
  setState,
  updateLabRequestQuoteFail,
  updateLabRequestQuoteSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestQuotes( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestQuotes, params.toString());
    yield put(setState(false))
    yield put(getLabRequestQuotesSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestQuotesFail(error));
  }
}

function* updateLabRequestQuote ({payload: labRequestQuoteObj }) {
  try {
    const response = yield call(getTable,`${labRequestQuotes}/${labRequestQuoteObj.id}`);
    yield put(updateLabRequestQuoteSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestQuoteFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* updateLabRequestQuoteStatus ({payload: labRequestQuoteObj }) {
  try {
    const response = yield call(getTable,`${labRequestQuotes}/${labRequestQuoteObj.id}`);
    yield put(updateLabRequestQuoteSuccess(response));
  } catch (error) {
    yield put(updateLabRequestQuoteFail(error));
  }
}

function* deleteLabRequestQuote ({payload: labRequestQuoteObj}) {
  try {
    yield put(deleteLabRequestQuoteSuccess(labRequestQuoteObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestQuoteFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestQuote ({ payload: labRequestQuote}) {
  try {
    yield put(setState(true))
    const response = yield call(postApiCall, labRequestQuotes ,labRequestQuote);
    // Después de crear, recargar la cotización completa desde el servidor
    const labRequestId = labRequestQuote.labRequest;
    const freshData = yield call(getTable, labRequestQuotes, `?limit=20&page=0&labRequest=${labRequestId}`);
    yield put(getLabRequestQuotesSuccess(freshData.items, freshData.totalPages, freshData.currentPage));
    yield put(setState(false))
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(setState(false))
    yield put(addLabRequestQuoteFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestQuotesSaga() {
  yield takeEvery(GET_LABREQUESTQUOTES, fetchLabRequestQuotes);
  yield takeEvery(ADD_NEW_LABREQUESTQUOTE, postingLabRequestQuote);
  yield takeEvery(UPDATE_LABREQUESTQUOTE, updateLabRequestQuote);
  yield takeEvery(UPDATE_LABREQUESTQUOTE_STATUS, updateLabRequestQuoteStatus);
  yield takeEvery(DELETE_LABREQUESTQUOTE, deleteLabRequestQuote);
}

export default labRequestQuotesSaga;
